/**
 * Pulsante "Ricontatta" dell'intestazione chat: apre le scelte rapide.
 * Se c'e' gia' un promemoria mostra la data e diventa arancione quando e' scaduto.
 */
import { useState } from 'react';
import { BellRing } from 'lucide-react';
import { tip, iconTip } from '@/components/messages/ChatTooltip';
import { formatRecontactDate } from '@/lib/services/whatsapp/recontactRules';
import { useChatRecontact } from './useChatRecontact';
import { RecontactPicker } from './RecontactPicker';

interface Props {
  chatKey: string;
  chatName: string;
  organizationId: string | null | undefined;
  compact?: boolean;
}

export function RecontactHeaderButton({ chatKey, chatName, organizationId, compact = false }: Props) {
  const { reminder } = useChatRecontact(chatKey, organizationId);
  const [picker, setPicker] = useState<{ x: number; y: number } | null>(null);
  const due = !!reminder && new Date(reminder.dueAt).getTime() <= Date.now();
  const hint = reminder
    ? `Ricontatto previsto il ${formatRecontactDate(reminder.dueAt)}${reminder.note ? `: ${reminder.note}` : ''}. Clic per rimandare o segnarlo fatto`
    : 'Ricontatta: promemoria per domani, tra 3 giorni, tra una settimana o una data a scelta';

  return (
    <>
      <button
        type="button"
        onClick={(e) => { const r = e.currentTarget.getBoundingClientRect(); setPicker({ x: r.right - 260, y: r.bottom + 4 }); }}
        aria-label="Ricontatta"
        {...(compact || !reminder ? iconTip(hint) : tip(hint))}
        className={`flex items-center gap-1 p-2 rounded transition-colors hover:bg-[rgba(55,53,47,0.08)] dark:hover:bg-white/10 ${due ? 'text-[#D9730D]' : reminder ? 'text-[#2383E2]' : 'text-[#6F6E69] dark:text-white/70'}`}
      >
        <BellRing className="w-4 h-4" />
        {reminder && !compact && <span className="text-xs font-medium">{formatRecontactDate(reminder.dueAt)}</span>}
      </button>
      {picker && (
        <RecontactPicker x={picker.x} y={picker.y} chatKey={chatKey} chatName={chatName} organizationId={organizationId} onClose={() => setPicker(null)} />
      )}
    </>
  );
}
